export default "__VITE_ASSET__r3s28zuN__"